<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="datePickerConfig.label"
        append-icon="mdi-calendar-search"
        readonly
        :value="dateDisp | formatDate"
        v-on="on"
        @click:clear="onClearClicked"
        :rules="rules"
        :clearable="clearable"
      />
    </template>
    <v-date-picker
      v-model="calVal"
      :picker-date.sync="pickerDate"
      locale="en-in"
      :min="datePickerConfig.minDate"
      :max="datePickerConfig.maxDate"
      no-title
      @input="onDateSelected"
    />
  </v-menu>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DatePickerInput",
  props: {
    datePickerConfig: Object,
    defaultValue: [String, Date, null],
    value: {
      type: [String, Date, null],
      default: null
    },
    rules: Array,
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateMenu: false,
      calVal: null,
      dateValue: null,
      pickerDate: null
    };
  },
  computed: {
    dateDisp() {
      return this.dateValue;
    }
  },
  watch: {
    dateMenu(val) {
      if (val && this.dateValue) {
        this.pickerDate = this.dateValue;
      }
    },
    defaultValue: {
      immediate: true,
      handler(newVal) {
        this.dateValue = newVal;
        this.calVal = newVal;
        this.pickerDate = newVal;
      }
    },
    value: {
      immediate: true,
      handler(val) {
        this.dateValue = val;
        this.calVal = val;
        this.pickerDate = val;
      }
    }
  },
  methods: {
    onClearClicked() {
      this.dateValue = null;
      this.calVal = null;
      this.pickerDate = null;

      this.$emit("input", null);
      this.$emit("updateDateField", this.datePickerConfig.field, null);
    },
    onDateSelected(newDate) {
      this.dateValue = newDate;
      this.pickerDate = newDate;
      this.$emit("input", newDate);
      this.$emit("updateDateField", this.datePickerConfig.field, newDate);
      this.dateMenu = false;
    }
  },
  filters: {
    formatDate(value) {
      return value ? dayjs(String(value)).format("MM/DD/YYYY") : "";
    }
  }
};
</script>
